import { TASK_COMPLETION } from '../util/constant';
import {
  GET_CLEANING_TASK_COMPLETION_FAIL,
  GET_CLEANING_TASK_COMPLETION_REQUEST,
  GET_CLEANING_TASK_COMPLETION_SUCCESS
} from './action';
import * as queries from './queries';

export function fetchCleaningTaskCompletionList(payload) {
  const { isoYear, isoMonth, isoWeek } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_CLEANING_TASK_COMPLETION_REQUEST });
      const clientResponse = await client.query({
        query: queries.getCleaningTaskCompletionList,
        variables: {
          isoYear,
          isoMonth,
          isoWeek
        }
      });

      const result = clientResponse?.data?.getTaskCompletion;

      const chartInfo = [];
      Object.keys(result).forEach((key) => {
        if (
          key === TASK_COMPLETION.Completed ||
          key === TASK_COMPLETION.Interrupted ||
          key === TASK_COMPLETION.Stopped
        ) {
          const chartItem = {
            type: key,
            value: result[key]
          };
          chartInfo.push(chartItem);
        }
      });

      const list = {
        data: chartInfo
      };
      dispatch({
        type: GET_CLEANING_TASK_COMPLETION_SUCCESS,
        payload: list
      });
    } catch (error) {
      dispatch({ type: GET_CLEANING_TASK_COMPLETION_FAIL, payload: { error } });
    }
  };
}
